import React from 'react';

/**
 * AI 모듈 전역에서 사용할 수 있는 기초 스켈레톤 부품.
 * Tailwind의 animate-pulse를 사용하여 로딩 중임을 시청각적으로 표현합니다.
 */
const AiSkeleton = ({ className = '', variant = 'rect' }) => {
    // 변체(variant)에 따른 기본 스타일 정의
    const baseStyles = 'bg-gray-100 animate-pulse';
    
    // 원형(circle), 사각형(rect), 텍스트 줄(text) 구분
    const variants = {
        circle: 'rounded-full',
        rect: 'rounded-xl',
        text: 'rounded-md h-4'
    };

    return (
        <div className={`${baseStyles} ${variants[variant] || variants.rect} ${className}`} />
    );
};

// 특정 형태를 미리 정의한 복합 컴포넌트들
export const SkeletonCircle = ({ size = '40px', className = '' }) => (
    <AiSkeleton variant="circle" className={className} style={{ width: size, height: size }} />
);

export const SkeletonRect = ({ className = '' }) => (
    <AiSkeleton variant="rect" className={className} />
);

export const SkeletonText = ({ width = '100%', className = '' }) => (
    <AiSkeleton variant="text" className={className} style={{ width }} />
);

export default AiSkeleton;
